import { IAppState } from '../../../AppModulesWrapper';
import { EPaymentStatus, EPaymentType } from '../../types/reducers/paymentProcessing';
import { selectPaymentDataByType } from './selectPaymentDataByType';

export const selectIsPublishPaymentStatusVisible = (state: IAppState): boolean => {
  const payment = selectPaymentDataByType(EPaymentType.Publish)(state);

  if (!payment?.status) {
    return false;
  }

  return payment.status !== EPaymentStatus.Succeeded;
};
